export default function(state={}, action){
    switch(action.type){
        case "MODAL_INFO":
            return action;
        default:
            return state;
    }
}